import { TooltipCode } from 'areas/shared/consts';

const IncorporationArticles = { 
    code: "IncorporationArticles", 
    visible: true,
    description: "Articles of Organization (Amendments, if applicable)",
    tooltipCode: TooltipCode.ARTICLE.ORGARTICLEUPLOAD
};

const IncorporationCertificate = { 
    code: "IncorporationCertificate", 
    visible: true,
    description: "Certificate of Organization",
    tooltipCode: TooltipCode.ARTICLE.ORGCERTIFICATEUPLOAD
};

const CorporateByLaws = { 
    code: "CorporateByLaws", 
    visible: false,
    description: ""
};

const ForeignEntityCertificate = {
    code: "ForeignEntityCertificate", 
    visible: true,
    description: "Foreign Entity Certificate",
    tooltipCode: TooltipCode.ARTICLE.FOREIGNENTCERUPLOAD
};

const OfficersElectedMinutes = { 
    code: "OfficersElectedMinutes", 
    visible: false,
    description: ""
};

const FirstBoardMeetingMinutes = { 
    code: "FirstBoardMeetingMinutes", 
    visible: true,
    description: "Minutes of organizational meeting or minutes of the 1st meeting",
    tooltipCode: TooltipCode.ARTICLE.ORGORFIRSTMEETINGUPLOAD
};

const MostRecentMeetingMinutes = { 
    code: "MostRecentMeetingMinutes", 
    visible: true,
    description: "Most recent Minutes of organizational meeting or minutes of the meeting",
    tooltipCode: TooltipCode.ARTICLE.MOSTREMEETINGMINUPLOAD
};

const CapitalContributionProof = { 
    code: "CapitalContributionProof", 
    visible: true,
    description: "Proof of Capital Investment by majority owner at time of company start or<br />owner's acquisition",
    tooltipCode: TooltipCode.ARTICLE.CAPINVESTPROOF
};

const StockPurchaseProof = { 
    code: "StockPurchaseProof", 
    visible: false,
    description: ""
};

const CorporateStockCertificates = { 
    code: "CorporateStockCertificates", 
    visible: false,
    description: ""
};

const CorporateStockLedger = {
    code: "CorporateStockLedger",
    visible: false,
    description: ""
};

const OperationalAgreement = {
    code: "OperationalAgreement",
    visible: false,
    description: ""
};

const BuyOutRights = {
    code: "BuyOutRights",
    visible: false,
    description: ""
};

const LimitedPartnershipCertificate = {
    code: "LimitedPartnershipCertificate",
    visible: false,
    description: ""
};

const LimitedPartnershipDocuments = {
    code: "LimitedPartnershipDocuments",
    visible: false,
    description: ""
};

const PartnershipAgreements = {
    code: "PartnershipAgreements",
    visible: false,
    description: ""
};

const ProfitSharing = {
    code: "ProfitSharing",
    visible: false,
    description: ""
};

const ThirdPartyAgreements = {
    code: "ThirdPartyAgreements",
    visible: false,
    description: ""
};

export default {
    IncorporationArticles,
    IncorporationCertificate,
    CorporateByLaws,
    ForeignEntityCertificate,
    OfficersElectedMinutes,
    FirstBoardMeetingMinutes,
    MostRecentMeetingMinutes,
    CapitalContributionProof,
    StockPurchaseProof,
    CorporateStockCertificates,
    CorporateStockLedger,
    OperationalAgreement,
    BuyOutRights,
    LimitedPartnershipCertificate,
    LimitedPartnershipDocuments,
    PartnershipAgreements,
    ProfitSharing,
    ThirdPartyAgreements
};


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/articles/UploadsConfig/SoleConfig.js